"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_pagination_1 = tslib_1.__importDefault(require("rc-pagination"));
var config_provider_1 = require("../../config-provider");
var DirectionDoubleleft_1 = require("../../Icons/DirectionDoubleleft");
var DirectionDoubleright_1 = require("../../Icons/DirectionDoubleright");
var DirectionLeft_1 = require("../../Icons/DirectionLeft");
var DirectionRight_1 = require("../../Icons/DirectionRight");
var select_1 = tslib_1.__importDefault(require("../../select"));
var useBreakpoint_1 = tslib_1.__importDefault(require("../../util/useBreakpoint"));
var MiniSelect_1 = tslib_1.__importDefault(require("./MiniSelect"));
var Pagination = function (_a) {
    var _b;
    var customizePrefixCls = _a.prefixCls, customizeSelectPrefixCls = _a.selectPrefixCls, className = _a.className, size = _a.size, customLocale = _a.locale, restProps = tslib_1.__rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);
    var xs = (0, useBreakpoint_1.default)().xs;
    var _c = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _c.getPrefixCls, direction = _c.direction;
    var prefixCls = getPrefixCls('pagination', customizePrefixCls);
    var getIconsProps = function () {
        var _a, _b;
        var ellipsis = React.createElement("span", { className: "".concat(prefixCls, "-item-ellipsis") }, "\u2022\u2022\u2022");
        var prevIcon = (React.createElement("button", { className: "".concat(prefixCls, "-item-link"), type: "button", tabIndex: -1 },
            React.createElement(DirectionLeft_1.DirectionLeft, null)));
        var nextIcon = (React.createElement("button", { className: "".concat(prefixCls, "-item-link"), type: "button", tabIndex: -1 },
            React.createElement(DirectionRight_1.DirectionRight, null)));
        var jumpPrevIcon = (React.createElement("a", { className: "".concat(prefixCls, "-item-link") },
            React.createElement("div", { className: "".concat(prefixCls, "-item-container") },
                React.createElement(DirectionDoubleleft_1.DirectionDoubleleft, { className: "".concat(prefixCls, "-item-link-icon") }),
                ellipsis)));
        var jumpNextIcon = (React.createElement("a", { className: "".concat(prefixCls, "-item-link") },
            React.createElement("div", { className: "".concat(prefixCls, "-item-container") },
                React.createElement(DirectionDoubleright_1.DirectionDoubleright, { className: "".concat(prefixCls, "-item-link-icon") }),
                ellipsis)));
        // change arrows direction in right-to-left direction
        if (direction === 'rtl') {
            _a = tslib_1.__read([nextIcon, prevIcon], 2), prevIcon = _a[0], nextIcon = _a[1];
            _b = tslib_1.__read([jumpNextIcon, jumpPrevIcon], 2), jumpPrevIcon = _b[0], jumpNextIcon = _b[1];
        }
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon,
        };
    };
    var locale = tslib_1.__assign({}, customLocale);
    var isSmall = size === 'small' || !!(xs && !size && restProps.responsive);
    var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    var extendedClassName = (0, classnames_1.default)((_b = {
            mini: isSmall
        },
        _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _b), className);
    return (
    // @ts-ignore
    React.createElement(rc_pagination_1.default, tslib_1.__assign({}, restProps, { prefixCls: prefixCls, selectPrefixCls: selectPrefixCls }, getIconsProps(), { className: extendedClassName, selectComponentClass: isSmall ? MiniSelect_1.default : select_1.default, locale: locale })));
};
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map